module.exports = __webpack_public_path__ + "img/level-1.c75aef52.svg";